import { Component } from '@angular/core';
import {
  DURATION_KPI_PANEL_IMPORTS,
  DurationKpiPanelComponent,
} from 'src/app/panels/components/kpi/duration-kpi-panel/duration-kpi-panel.component';
import { DisplayUnit } from 'src/app/panels/models/display-unit';
import { PanelType } from 'src/app/panels/models/panel-type';
import { Color } from 'src/app/shared/services/color/colors';
import { PanelComponent } from '../../../../../panels/components/panel.component';

@PanelComponent.register
@Component({
  templateUrl: '../../../../../panels/components/kpi/duration-kpi-panel/duration-kpi-panel.component.html',
  styleUrl: '../../../../../panels/components/kpi/duration-kpi-panel/duration-kpi-panel.component.scss',
  selector: 'app-co2-level-duration-kpi-panel',
  imports: DURATION_KPI_PANEL_IMPORTS,
})
export class Co2LevelDurationKpiPanelComponent extends DurationKpiPanelComponent {
  public static override readonly type = PanelType.Co2LevelDurationKpi;
  public override title = `Hoog ${DisplayUnit.Co2} niveau`;
  public override icon = 'bi-exclamation-triangle-fill';
  public override unit = DisplayUnit.None;
  public override color = Color.Red;
}
